
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gohmXFInMK89EbNu0a3wib0uGmnbejHVmDP1IGA9fQ8oMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index6e04jRCVSohQE7lfAlH_9dGczRobTFJ6W9BfHsadBNsMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchur8U8RGrslfOJhtCQsBNvlPc6Lz3fNh_45OUspNSPrJNQMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexIEK5emcg4FDncXBUtlK_rcaA4je607uVAAYhVTk0HPEMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93HmeS_45nXXeRbHCPs5GylUlfRRuil0S4cz_45_45uJG3ilZaYMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indextH0FbVICOQlA4aWLffn2eNc2cVpHsOwhr4248KoKh_IMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93We7vg3ORd2KPJtiqSSa0wDAV2Iz9LepXTa3E6qM5lTUMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index6Rzuan9lZFlqZA8y2hhRh3It8D97017wvnGQyLoQWCcMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_932g_45PTeBm9ofZnmZvru8l9pQkjDpr7rPrsylKLvMGi_45IMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexo3xl49OUL3vVh_2GVtREMTrir3SdElI_45Bxz7PhHTyEIMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexKbCXfUi9TlJRnKiC5WzbAbfoVnjwrdGv6WWNMbVSzLwMeta } from "/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indextH0FbVICOQlA4aWLffn2eNc2cVpHsOwhr4248KoKh_IMeta || {},
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index6Rzuan9lZFlqZA8y2hhRh3It8D97017wvnGQyLoQWCcMeta || {},
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexo3xl49OUL3vVh_2GVtREMTrir3SdElI_45Bxz7PhHTyEIMeta || {},
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexKbCXfUi9TlJRnKiC5WzbAbfoVnjwrdGv6WWNMbVSzLwMeta || {},
    component: () => import("/codebuild/output/src3121621135/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]